export const GET_TRIP_RECORD = "GET_TRIP_RECORD";
export const SET_TRIP_RECORD_SELECTED_TRID = "SET_TRIP_RECORD_SELECTED_TRID";
export const CLEAR_TRIP_RECORD_SELECTED_TRID = "CLEAR_TRIP_RECORD_SELECTED_TRID";
export const SET_TRIP_RECORD_SELECTED_DATE_AND_INDEX = "SET_TRIP_RECORD_SELECTED_DATE_AND_INDEX";
export const CLEAR_TRIP_RECORD_SELECTED_DATE_AND_INDEX = "CLEAR_TRIP_RECORD_SELECTED_DATE_AND_INDEX";
